// https://app.growthbook.io/features/pen-7647_v1
export const EXPERIMENT_FLAG = 'pen-7647_v1'

export type GiftHeroCardBucket = 'control' | 'variant_1'

export type GiftHeroCards = {
  top: string
  middle: string
  back: string
}

export const VARIANT_1_HERO_CARDS: GiftHeroCards = {
  top: 'generic',
  middle: 'thanks-dad',
  back: 'happy-birthday',
}
